import {Icon} from '@components/@icons';
import {useVideoPlayer} from '@components/@ui/VideoPlayer/useVideoPlayer';
import {FC, memo} from 'react';
import styles from './VideoNotStartedPlayButton.module.css';

const VideoNotStartedPlayButton: FC = memo(
    function VideoNotStartedPlayButton() {
        const {play} = useVideoPlayer();

        return (
            <button onClick={play} className={styles.playBtnWrapper}>
                <span className={styles.notStartedContainer}>
                    <Icon name="play" height={'1.125rem'} width={'1.125rem'} />
                    <div className={styles.notStartedText}>Play</div>
                </span>
            </button>
        );
    },
);

export default VideoNotStartedPlayButton;
